module.exports = __webpack_public_path__ + "img/VN.aa85b0dc.jpg";